import { Fragment, useCallback, useEffect, useState } from 'react';

import { toCSV } from 'utils/clickme';
import { FILE_DATE_WITH_TIME_FORMAT } from 'utils/constants/date';
import { formatDate } from 'utils/date';

import { useRequestCancel } from 'hooks/common/useRequestCancel';
import useTrls from 'hooks/translation/useTrls';

import ActsTable from 'components/Admin/Reports/ActsReport/ActsTable/ActsTable';
import { fetchActs } from 'components/Admin/Reports/ActsReport/fetchActs';
import InputWithDatePicker from 'components/Admin/Reports/ActsReport/Filter/InputWithDatePicker';
import SelectAdvertisingServiceType from 'components/Admin/Reports/ActsReport/Filter/SelectAdvertisingServiceType';
import SelectProcessingType from 'components/Admin/Reports/ActsReport/Filter/SelectProcessingType';
import SelectStatus from 'components/Admin/Reports/ActsReport/Filter/SelectStatus';
import SelectType from 'components/Admin/Reports/ActsReport/Filter/SelectType';
import Total from 'components/Admin/Reports/ActsReport/Total';
import ReportWrapper from 'components/Admin/Reports/ReportWrapper';

import { resetFilters } from 'store/models/acts';
import { useDispatch, useSelector } from 'store/utils';

import 'components/Admin/Reports/ActsReport/ActsReport.less';

const ActsReport = () => {
    const [isReportFetched, setIsReportFetched] = useState(false);
    const { acts, isLoad, statuses, selectTypes, advertisingServiceType, processingType } = useSelector(
        (state) => state.acts
    );
    const dispatch = useDispatch();
    const trl = useTrls();
    const { abortRequest, abortSignal } = useRequestCancel();

    const onClickCSV = useCallback(() => {
        const actsWithRightAmount = acts.map((act) => {
            const newAct = { ...act };
            const { correctedAmount, amount } = newAct;
            newAct.amount = correctedAmount || amount;
            return newAct;
        });
        const currentDate = formatDate(new Date(), FILE_DATE_WITH_TIME_FORMAT);
        const fileName = `monthly_act_${currentDate}_${statuses}_${selectTypes}_${advertisingServiceType}_${processingType}.csv`;
        const headers = ['actName', 'employerId', 'amount', 'type', 'status'];
        const sum = actsWithRightAmount.reduce((sum, { amount }) => sum + amount, 0);
        const total = ['', '', sum, '', ''];
        toCSV(fileName, actsWithRightAmount, headers, total);
    }, [acts, selectTypes, statuses, advertisingServiceType, processingType]);

    const onClickSearch = () => {
        setIsReportFetched(true);
        abortRequest();
        dispatch(fetchActs(false, abortSignal()));
    };

    useEffect(() => {
        dispatch(resetFilters());
    }, [dispatch]);

    return (
        <ReportWrapper
            title={trl('admin.actsReport.title')}
            filter={
                <Fragment>
                    <InputWithDatePicker />
                    <SelectAdvertisingServiceType />
                    <SelectProcessingType />
                    <SelectType />
                    <SelectStatus />
                </Fragment>
            }
            content={
                isReportFetched && (
                    <div className="acts-report-content">
                        <div className="acts-report-table">
                            <ActsTable />
                        </div>
                        <div className="acts-report-total">
                            <Total />
                        </div>
                    </div>
                )
            }
            isLoadContent={isLoad}
            onClickSearch={onClickSearch}
            onClickClear={() => dispatch(resetFilters(null))}
            onClickCSV={onClickCSV}
        />
    );
};

export default ActsReport;
